








































import Vue from 'vue';
import {mapState} from 'vuex';
import CatchmentTable from './CatchmentTable.vue';
import * as types from '@/store/types'
import * as actions from '@/store/actions'

export default Vue.extend({
  name: 'InfoTray',

  components: {
    CatchmentTable,
  },

  data () {
    return {
      drawer: false,
      tabs: ['Catchment', 'Microplan', 'Area', 'Site'],
      fields: [{value: "field.label", text: "Field"}, {value: "value", text:"Value"}],
      items: [],
      tabNumber: 0,
      showCreateCampaign: false,
      title: ""
    }
  },

  computed: mapState({
    user: (state: any) => (state.user as types.Schema$User),
    loggedIn: (state: any, getters: any) => getters.loggedIn,
    tab: (state: any) => state.dataTab,
    //TODO: this is an ugly hack and should be banished to the ends of the earth
    tabIndex: (state: any) => ['Catchment', 'Microplan', 'population', 'Site'].findIndex((s) => s.toLowerCase() === state.dataTab),
    showData: (state: any) => (state.showData),
    siteName: (state: any) => (state.data.site.name || state.data.site['Localty']),
    siteId: (state: any) => (state.data.site.id),
    allData: (state: any) => (state.data),
    microplan: (state: any) => {
      const number = state.data.microplan.items.find((i) => i.field.label === 'bin') || ""
      return number.value
    }


      
  }),

  methods: {
    onHideDataWindow() {
      this.$store.commit(actions.TOGGLE_DATA_WINDOW)
    },

    onTabChange(number: number) {
      this.tabNumber = number
      switch(this.tabs[number]) {
        case "Catchment":
          this.$store.commit(actions.SET_TAB, "catchment")
          break
        case "Microplan":
          this.$store.commit(actions.SET_TAB, "microplan")
          break
        case "Area":
          this.$store.commit(actions.SET_TAB, "population")
          break
        case "Site":
          this.$store.commit(actions.SET_TAB, "site")
          break
      }
    }
  }
});
